import React from 'react'

const css = {
  fontSize: '30px',
  fontWeight: 'bold',
  color: '#ff4438',
  textAlign: 'center',
  padding: '0.5em 35px'
}

export default function Subtitle ({ text }) {
  return (
    <div style={css}>
      {text}
    </div>
  )
}
